import SparqlClient from 'sparql-http-client';
import moment from 'moment';

export interface DecompositionObservedData {
  id: string;
  TimeWindow: Date;
  TotalTraffic: number;
}

const parseDataDecompositionObserved = (data: string): DecompositionObservedData[] => {
  const rows = data.trim().split('\n').slice(1); // Split data into rows and remove header
  const dataPoints: Record<string, DecompositionObservedData> = {}; // Using an object instead of an array

  rows.forEach(row => {
    const [idRaw, columnRaw, valueRaw] = row.split('\t');
    const id: string = idRaw.match(/\d+/g)?.pop() ?? '';
    if (!dataPoints[id]) {
      dataPoints[id] = { id: id, TimeWindow: new Date(), TotalTraffic: 0 };
    }
    if (columnRaw.includes('TimeWindow')) {
      const parsedDate = moment(valueRaw, 'MM/DD/YYYY HH:mm');
      if (parsedDate.isValid()) {
        dataPoints[id].TimeWindow = parsedDate.toDate(); // Use moment to convert to JS Date
      } else {
        console.error('Invalid date format:', valueRaw);
      }
    } else if (columnRaw.includes('TotalTraffic')) {
      const numberValue = Number.parseFloat(valueRaw.replace(/[^\d.-]/g, ''));
      if (isNaN(numberValue)) {
        console.error('Invalid number format:', valueRaw);
      } else {
        dataPoints[id].TotalTraffic = numberValue;
      }
    }
  });

  // Convert the object to an array of DataPoints
  return Object.values(dataPoints);
};

// Function to fetch data from SPARQL endpoint
const getDataDecompositionObserved = async (): Promise<DecompositionObservedData[]> => {
  const PROJECT_URL = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/datastores';
  const DATASET_URL = PROJECT_URL + '/decomposition_observed';
  const ENDPOINT_URL = DATASET_URL + '/sparql';

  const query = `
    PREFIX project: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix>
    PREFIX input: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/input>
    PREFIX output: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/output>

    SELECT ?S ?P ?O
    WHERE {
        ?S ?P ?O
    }
    LIMIT 100000
  `;

  const client = new SparqlClient({ endpointUrl: ENDPOINT_URL });
  const stream = client.query.select(query);
  const rawData: string[] = [];

  return new Promise((resolve, reject) => {
    stream.on('data', (row: { [key: string]: any }) => {
      const idRaw = row['S'].value;
      const columnRaw = row['P'].value;
      const valueRaw = row['O'].value;
      // You might need to process or transform the data here, depending on your specific needs
      rawData.push(`${idRaw}\t${columnRaw}\t${valueRaw}`);
    });

    stream.on('end', () => {
      const tableData = parseDataDecompositionObserved(rawData.join('\n'));
      resolve(tableData);
    });

    stream.on('error', (err: any) => {
      console.error('Network error:', err);
      reject(new Error('Failed to fetch data from the SPARQL endpoint.'));
    });
  });
};

export default getDataDecompositionObserved;
